import { useTranslation } from "react-i18next";

import expiredIcon from "src/assets/svgs/tacho-card-expired.svg?url";
import inactiveIcon from "src/assets/svgs/tacho-card-inactive.svg?url";
import offlineIcon from "src/assets/svgs/tacho-card-offline.svg?url";
import onlineIcon from "src/assets/svgs/tacho-card-online.svg?url";
import unregisteredIcon from "src/assets/svgs/tacho-card-unregistered.svg?url";

import type { TachographCardStatus } from "src/services/tachographCardService";
import { CustomTag } from "sipli-fleet-core/components/CustomSharedTag";

const STATUS_BADGES = {
  0: {
    translationKey: "offline",
    icon: offlineIcon,
    className: "gap-2 bg-red-soft text-red-shade",
  },
  1: {
    translationKey: "online",
    icon: onlineIcon,
    className: "gap-2 bg-status-driving-bg text-green-shade",
  },
  2: {
    translationKey: "inactive",
    icon: inactiveIcon,
    className: "gap-1 bg-gray1 text-gray8",
  },
  3: {
    translationKey: "expired",
    icon: expiredIcon,
    className: "gap-2 bg-red-soft text-red-shade",
  },
  4: {
    translationKey: "not_registered",
    icon: unregisteredIcon,
    className: "gap-2 bg-[#FFF5E2] text-[#C08200] font-[600]",
  },
} satisfies Record<
  TachographCardStatus,
  {
    translationKey: string;
    icon: string;
    className: string;
  }
>;

interface TachographCardStatusCellProps {
  status?: TachographCardStatus | null;
}

const TachographCardStatusCell = ({ status }: TachographCardStatusCellProps) => {
  const { t } = useTranslation();

  // null/undefined should have the same behavior as status 4
  const normalizedStatus: TachographCardStatus = status ?? 4;

  const badge = STATUS_BADGES[normalizedStatus];

  if (!badge) return null;

  return (
    <CustomTag
      className={badge.className}
      icon={<img src={badge.icon} alt="" />}
    >
      {t(badge.translationKey)}
    </CustomTag>
  );
};

export default TachographCardStatusCell;
